import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'


const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/front/home/home.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '../views/admin/register.vue')
    },
    {
        path: '/DetailCourse/:id',
        name: 'DetailCourse',
        component: () => import(/* webpackChunkName: "detail" */ '../views/front/course/DetailCourse.vue')
    },
    {
        path: '/fee-info',
        name: 'fee-info',
        component: () => import(/* webpackChunkName: "fee-info" */ '../views/front/order/fee-info.vue')
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import(/* webpackChunkName: "feedback" */ '../views/front/feedback/feedback.vue')
    },
    {
        path: '/CourseList',
        name: 'CourseList',
        component: () => import(/* webpackChunkName: "CourseList" */ '../views/front/course/CourseList.vue')
    },
    {
        path: '/AuthorList',
        name: 'AuthorList',
        component: () => import(/* webpackChunkName: "AuthorList" */ '../views/front/author/AuthorList.vue')
    },
    {
        path: '/AuthorDetail/:id',
        name: 'AuthorDetail',
        component: () => import(/* webpackChunkName: "AuthorDetail" */ '../views/front/author/AuthorDetail.vue')
    },
    {
        path: '/payment/:type',
        name: 'payment',
        component: () => import(/* webpackChunkName: "payment" */ '../views/front/order/payment.vue')
    },
    {
        path: '/payBao/',
        name: 'payBao',
        component: () => import(/* webpackChunkName: "payBao" */ '../components/payBao.vue')
    },
    {
        path: '/userFrame',
        name: 'userFrame',
        component: () => import(/* webpackChunkName: "userFrame" */ '../views/front/user/userFrame.vue'),
        children: [
            {
                path: '/PasswordSet',
                name: 'PasswordSet',
                component: () => import(/* webpackChunkName: "PasswordSet" */ '../views/front/user/PasswordSet.vue')
            },
            {
                path: '/BuyCourse',
                name: 'BuyCourse',
                component: () => import(/* webpackChunkName: "BuyCourse" */ '../views/front/user/BuyCourse.vue')
            },
            {
                path: '/LearningRecord',
                name: 'LearningRecord',
                component: () => import(/* webpackChunkName: "LearningRecord" */ '../views/front/user/LearningRecord.vue')
            },
            {
                path: '/RequiredCourse',
                name: 'RequiredCourse',
                component: () => import(/* webpackChunkName: "RequiredCourse" */ '../views/front/user/RequiredCourse.vue')
            },
            {
                path: '/MyOrder',
                name: 'MyOrder',
                component: () => import(/* webpackChunkName: "MyOrder" */ '../views/front/user/MyOrder.vue')
            },
            {
                path: '/UserInfo',
                name: 'UserInfo',
                component: () => import(/* webpackChunkName: "UserInfo" */ '../views/front/user/UserInfo.vue')
            },
            {
                path: '/Collection',
                name: 'Collection',
                component: () => import(/* webpackChunkName: "Collection" */ '../views/front/user/Collection.vue')
            }
        ]
    },

    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/admin/login.vue')
    },
    {
        path: '/frame',
        name: 'frame',
        component: () => import(/* webpackChunkName: "frame" */ '../components/frame.vue'),
        children: [
            {
                path: '/course-set',
                name: 'course-set',
                component: () => import(/* webpackChunkName: "course-set" */ '../views/enterprise/course/course-set.vue')
            },
            {
                path: '/staff-study',
                name: 'staff-study',
                component: () => import(/* webpackChunkName: "staff-study" */ '../views/enterprise/staff/staff-study.vue')
            },
            {
                path: '/study-detail',
                name: 'study-detail',
                component: () => import(/* webpackChunkName: "study-detail" */ '../views/enterprise/staff/study-detail.vue')
            },
            {
                path: '/employee-list',
                name: 'employee-list',
                component: () => import(/* webpackChunkName: "course-set" */ '../views/enterprise/user/employee-list.vue')
            },
            {
                path: '/business-info',
                name: 'business-info',
                component: () => import(/* webpackChunkName: "business-info" */ '../views/enterprise/user/business-info.vue')
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
